import {
  bankConnectionSchema,
  type BankConnection,
  type ConnectBankBody,
} from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postConnection = (body: ConnectBankBody): Promise<unknown> =>
  apiRequest<unknown>('/bank/connection', { method: 'POST', body });

export const connectBank = async (body: ConnectBankBody): Promise<BankConnection> =>
  bankConnectionSchema.parse(await postConnection(body));
